/** @format */

import React, { useRef, useState } from "react";
import PageLayout from "../../components/PageLayout";
import FaqIcon from "../../components/SvgIcons/FaqIcon";
import FaqIconUP from "../../components/SvgIcons/FaqIconUP";
import { Link } from "react-router-dom";

export default function Faqs() {
  const [activeIndex, setActiveIndex] = useState(0);
  const contentRefs = useRef([]);

  const faqs = [
    {
      question:
        "Why should I use Paths if I already use other social media platforms?",
      answer:
        "Feel free to continue using your other social media platforms. Paths is designed to complement them. It allows you to take the most important posts from those networks and use them as memory triggers to build deeper connections and shared experiences with the people most relevant to those memories.",
    },
    {
      question: "Privacy is important to me. What does Paths do with my data?",
      answer:
        "We take your privacy seriously and do nothing with your personal data. We can’t access the content you share unless it’s reported for abuse. In those cases, we review the flagged entry, but we don’t know who owns the content—it’s not linked to your name.",
    },
    {
      question:
        "What devices support Paths? Can I download it on my PC, phone, and tablet?",
      answer: "Paths is available on iOS, Android, and as a Desktop/Web App.",
    },

    {
      question: "How do I follow friends?",
      answer: (
        <>
          <p>Method 1: Simply navigate to their feed and tap “Follow.”</p>
          <p>
            Method 2: Go to the “Manage Others” screen, located to the left of
            the center “+” button for adding entries (it’s represented by an
            icon of three people). Tap the “Find More Of Your People” bar at the
            bottom of the screen. Start typing the name of the person you want
            to follow, and the list will filter to show the matching results.
          </p>
        </>
      ),
    },
    {
      question: "What does collaborating on a post mean?",
      answer:
        "Collaborating on a post is what the CollabTab(TM)feature in Paths enables. Unlike typical social media posts, the CollabTab(TM) allows multiple users to contribute their entries to a single post. When someone “co-owns” a post with you in Paths, you are effectively collaborating on that post.",
    },
    {
      question: "How do I add posts to my timeline?",
      answer: (
        <>
          <p>
            When you first join, you’ll have the option to pull in your content
            from Facebook, allowing you to instantly load those meaningful
            moments.
          </p>
          <p>
            Additionally, you can go to Settings and tap the PastPuller(TM)
            button to view a list of social networks and services you can
            integrate into your Path.
          </p>
        </>
        // <ul>
        //   <li>Method 1: Just navigate to their feed and tap “follow”.</li>
        //   <li>
        //     Method 2: Navigate to the “Manage Others” screen to the left of the
        //     center “+” button for adding entries. It’s got the icon of 3 peeps.
        //     Tap the “Find More Of Your People” bar at the bottom of the screen.
        //     Begin typing somebody’s name that you want to follow and allow the
        //     list to filter down to the person you seek. They must be an existing
        //     Paths user to be found here.
        //   </li>
        // </ul>
      ),
    },
    {
      question: "How do I remove posts from my timeline?",
      answer:
        "Whenever you see an entry you’ve created—whether it’s a solo post or part of a CollabTab(TM)—tap the three vertical dots in the top-right corner of the entry to access more options. One of the options is “Delete,” which will remove the post from your timeline.",
    },
    {
      question: "Can I control who sees my timeline?",
      answer: (
        <>
          <p>Yes, you have two ways to control who sees your content:</p>
          <ul>
            <li>
              1. Private Account: If you set your entire account to Private
              (found in Settings > Account), you will need to approve people who
              request to follow your Path.
            </li>
            <li>
              2. Private Entry: When you create or edit an entry in Paths, you
              can choose to save it as Private instead of Public. A Private
              entry can only be seen by you, unless you invite someone to
              collaborate on the post. In that case, only the other
              collaborators will be able to see the entry.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "I use more social media sites than what you support. What sites do you plan to add support for in the future?",
      answer: (
        <>
          <p>
            We aimed to cover the most common digital footprints from the turn
            of this century to today, so we started with Facebook, Instagram,
            Myspace, and Blogger. The next round of PastPuller(TM) network
            integrations will be a surprise, but rest assured, we don’t plan to
            stop with these.
          </p>
          <p>
            We would also appreciate any feedback or suggestions for other
            platforms you’d like to see integrated with Paths in the future.
            Please feel free to reach out to us at{" "}
            <a href='mailto:feedback@getpaths.com'>feedback@getpaths.com</a>.
          </p>
        </>
      ),
    },
    {
      question: "How do I zoom in and out on my timeline?",
      answer: (
        <div>
          <p>
            Just like with any map software (e.g., Google Maps, Waze, Apple
            Maps), you can zoom in by pinching two fingers on the screen, and
            zoom out by spreading your fingers apart.
          </p>
          <p>You can also double-tap a specific spot to zoom in slightly.</p>
        </div>
      ),
    },
    {
      question:
        "Can I still use Paths if I don’t have any other social media accounts?",
      answer:
        "Absolutely! You can start your life story fresh by using Paths to create new entries directly. Add photos, titles, descriptions, and more to build your story from scratch!",
    },
    {
      question: "How do I send messages to people in Paths?",
      answer:
        "Paths allows you to communicate through comments on posts you’re invited to collaborate on. However, we do not offer direct messaging to ensure the safety and security of our users.",
    },
    {
      question: "Can I delete comments on my posts if I don’t like them?",
      answer:
        "Not yet, but that’s a great suggestion! We’ll consider adding this feature in the future.",
    },
    {
      question: "Can I block people on Paths?",
      answer: (
        <>
          <p>
            Yes, you can block users on Paths, and they won’t be notified when
            you do. To block someone, go to their feed, tap the three horizontal
            dots (…) in the top-right corner, and select “Block this account.”
          </p>
          <p>
            Please note: While blocking a user prevents them from seeing your
            profile and timeline, they may still see comments you’ve made in
            shared threads or any public CollabTab(TM) entries you’ve
            contributed to if they follow another collaborator.
          </p>
        </>
      ),
    },
    {
      question: "What are upgrades, and what do they do?",
      answer:
        "Upgrades are additional features available in the Upgrades Marketplace section of the app. Some upgrades are free, while others are available as in-app purchases. These features are designed to help you customize and enhance your experience on Paths, tailoring the platform to better suit your needs.",
    },
    {
      question: "What is PastPuller(TM)?",
      answer:
        "PastPuller(TM) is an integration with third-party social networks, blogs, or other services that “pull” content from these sources to serve as prompts for building your more permanent path.  PastPuller(TM) delivers this external content directly into your app’s feed and Tandem Timeline™, where you can choose to save it as either Private or Public.",
    },
    {
      question: "How do I send you feedback?",
      answer: (
        <p>
          We’re eager to hear from you so we can continually improve Paths for
          you! For technical issues, please use our ticketing system so our team
          can promptly address your concerns. For general ideas or suggestions,
          feel free to email us at{" "}
          <a href='mailto:feedback@getpaths.com'>feedback@getpaths.com</a>.
        </p>
      ),
    },
    {
      question: "How can I report a bug?",
      answer: (
        <>
          <p>
            To report a bug, please use our ticketing system. This allows us to
            maintain clear communication with you while addressing the issue.
            Sometimes, resolving a bug requires a few back-and-forth exchanges
            to fully understand and tackle the root cause.
          </p>
          {/* <p>*need a link included to report the bug</p> */}
        </>
      ),
    },
    {
      question: "How can I invite my friends to join Paths?",
      answer: (
        <>
          <p>There are several ways to invite your friends to join Paths:</p>
          <ul>
            <li>
              1. Start a CollabTab(TM): Create an entry and invite your friends
              by tapping the green “+” button. This will open your device’s
              sharing options, allowing you to send an invite directly to
              CollabTab(TM) you’ve started via your preferred channel.
            </li>
            <li>
              2. Share the website: Send them to{" "}
              <a href='https://www.getpaths.com/' target='_blank'>
                www.getpaths.com
              </a>
            </li>
            <li>3. Share App Store links:</li>
            <li>
              <div className='playstore'>
                <Link
                  to='https://apps.apple.com/us/app/paths-friends-memories-life/id1480890359'
                  target='_blank'
                >
                  <img
                    src='../images/android.png'
                    alt='android'
                    className='img-fluid'
                  />
                </Link>
                <Link
                  to='https://play.google.com/store/apps/details?id=com.getpaths.paths'
                  target='_blank'
                >
                  <img
                    src='../images/googlepaly.png'
                    alt='googlepaly'
                    className='img-fluid'
                  />
                </Link>
              </div>
            </li>
          </ul>
          <p>Let’s grow your network on Paths!</p>
        </>
      ),
    },
    {
      question: "What is a private account?",
      answer:
        "A private account is one where the account owner must approve anyone who requests to follow them. This ensures greater control over who can view your content, unlike an open account, which allows anyone to follow you without prior approval.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };
  return (
    <PageLayout>
      <div className='container'>
        <div className='faq-main'>
          {/* <h2 className="titletwo">
            Need some <span>direction?</span>
            <br /> Check out our walkthrough <span>video</span>
          </h2>
          <video className="videofaq" controls>
            <source src="images/file.mp4" type="video/mp4" />
          </video> */}

          <div className='faqtabs'>
            <h2>Here are some FAQ's that Paths users find helpful:</h2>

            <div className='faq-container'>
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`faq-item ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  <div
                    className='faq-question'
                    onClick={() => toggleFAQ(index)}
                  >
                    {faq.question}
                    <span className='icon'>
                      {activeIndex === index ? <FaqIconUP /> : <FaqIcon />}
                    </span>
                  </div>
                  <div
                    ref={(el) => (contentRefs.current[index] = el)}
                    className='faq-answer'
                    style={{
                      maxHeight:
                        activeIndex === index
                          ? contentRefs.current[index]?.scrollHeight
                          : 0,
                    }}
                  >
                    {faq.answer}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
